<template>
  <div class="com-sku-card" @click="onClickBtn">
    <OutOpen
      :protocol="heyboxProtocol"
      :page-identifier="'bbs/link'"
      v-if="canUseDeepLink && articleInfo.source == 'share'"
    ></OutOpen>
    <template v-if="!is_loading">
      <div class="sku-img-box" v-report.exposure="getReportConfig">
        <img v-hb-img.src="card_data.head_image" alt="" class="sku-img" />
      </div>
      <div class="sku-info-box">
        <p class="line-1">{{ card_data.name }}</p>
        <div class="line-2">
          <div class="price-box" :style="{ visibility: hiddenPrice }">
            <div class="price-content-box">
              <hb-icon :name="platform" />
              <hb-icon bbs-money />
              <span class="current-price">{{ current_price }}</span>
              <p class="original-price" v-if="discount">
                <hb-icon bbs-money />
                <span class="price-num">{{ original_price }}</span>
              </p>
            </div>
            <div class="tag-box" v-if="discount">-{{ discount }}%</div>
          </div>
          <div class="follow-btn">购买</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { CptMixin } from '../../../mixins/CptMixin';
import { executeProtocol, executeProtocolOutApp } from '_lib/utils';
import { HeyboxReportDirectiveOptions } from '_lib/plugin/heybox-report';
import OutOpen from '_com/OutOpen';
export default {
  mixins: [CptMixin],
  props: {
    canUseDeepLink: {
      type: Boolean,
    },
  },
  data() {
    return {
      is_loading: true,
      card_data: {},
      current_price: '',
      original_price: '',
      discount: '',
      platform: 'bbs-heybox-platform_v',
    };
  },
  created() {
    this.getData();
  },
  components: {
    OutOpen,
  },
  methods: {
    async getData() {
      const {
        data: { result, status },
      } = await this.dataInfo.request;
      if (status != 'ok') {
        return;
      }
      this.card_data = result.find((item) => item.sku_id == this.dataInfo.id);
      if (!this.card_data) return;
      if (this.card_data.price) {
        this.current_price = ~~(this.card_data.price.final_price / 1000);
        this.original_price = ~~(this.card_data.price.initial_price / 1000);
      }
      this.is_loading = false;
    },
    onClickBtn() {
      switch (this.articleInfo.source) {
        case 'share': {
          executeProtocolOutApp(this.heyboxProtocol);
          break;
        }
        case 'post': {
          executeProtocol({
            protocol_type: 'openMallProduct',
            sku_id: this.card_data.sku_id,
          });
          break;
        }
      }
    },
    getReportConfig() {
      switch (this.articleInfo.source) {
        case 'share': {
          return {};
        }
        case 'post': {
          return {
            path: '/mall/sku/show',
            type: '3',
            addition: {
              sku_id: this.dataInfo.id,
              idx: this.dataInfo.index,
              h_src: this.articleInfo.options?.h_src ?? this.card_data.h_src,
              link_id: this.articleInfo.origin_data.linkid,
            },
          };
        }
      }
    },
  },
  computed: {
    hiddenPrice() {
      return this.current_price ? 'visible' : 'hidden';
    },
    heyboxProtocol() {
      return (
        'heybox://' +
        encodeURIComponent(
          JSON.stringify({
            protocol_type: 'openMallProduct',
            sku_id: this.card_data.sku_id,
          }),
        )
      );
    },
  },
  directives: {
    report: HeyboxReportDirectiveOptions,
  },
};
</script>

<style lang="less">
.com-sku-card {
  position: relative;
  display: flex;
  align-items: center;
  height: 80px;
  margin-top: 12px;
  padding: 8px 10px;
  border-radius: 8px;
  background: rgba(250, 251, 252, 1);
  &::after {
    content: '';
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    width: 200%;
    height: 200%;
    border-radius: 16px;
    border: 1px solid rgba(243, 244, 245, 1);
    transform: scale(0.5);
    transform-origin: left top;
    pointer-events: none;
  }
  .sku-img-box {
    width: 64px;
    height: 64px;
    .sku-img {
      width: inherit;
      height: inherit;
      border-radius: 4px;
      object-fit: scale-down;
    }
  }
  .sku-info-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 0;
    margin-left: 10px;
    .line-1 {
      width: 80%;
      height: 21px;
      font-size: 14px;
      font-weight: 500;
      color: rgba(20, 25, 30, 1);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 21px;
    }
    .line-2 {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      width: 100%;
      height: 24px;
      margin-top: 2px;
      .price-box {
        display: inline-flex;
        align-items: center;
        border-radius: 2px;
        background: rgb(243, 244, 245);
        overflow: hidden;
        .price-content-box {
          display: inline-flex;
          align-items: center;
          height: 14px;
          color: rgba(20, 25, 30, 1);
          padding: 1px 3px;
          .platform-logo {
            width: 11px;
            height: 11px;
          }
          i {
            font-size: 11px;
            font-weight: 500;
          }
          .current-price {
            font-size: 12px;
            font-weight: 700;
            line-height: 14px;
          }
          .original-price {
            display: inline-flex;
            align-items: center;
            font-size: 10px;
            color: rgba(140, 145, 150, 1);
            i {
              line-height: 13px;
              font-weight: 400;
            }
            .price-num {
              font-size: 10px;
            }
          }
        }
        .tag-box {
          height: 16px;
          padding: 0 3px;
          font-size: 10px;
          font-weight: 700;
          color: rgba(255, 255, 255, 1);
          line-height: 16px;
          background: rgba(64, 68, 73, 1);
          color: #ffffff;
          font-family: Helvetica;
        }
      }
      .follow-btn {
        padding: 4px 8px;
        font-size: 12px;
        line-height: 16px;
        color: rgba(255, 255, 255, 1);
        border-radius: 3px;
        background: rgba(20, 25, 30, 1);
      }
    }
  }
}
</style>
